'use client';

import { createContext } from 'react';

export const ProductContext = createContext(undefined);
export const ProductSelectionContext = createContext(undefined);
